import { createFileRoute } from '@tanstack/react-router'
import PageRedeemInvite from '@/pages/account/redeem-invite'

export const Route = createFileRoute('/app/account/redeem-invite/$inviteToken')({
  component: RouteComponent,
})

function RouteComponent() {
  const { inviteToken } = Route.useParams()

  return <PageRedeemInvite inviteToken={inviteToken} />
}
